var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLinkSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  viewBox: "0 0 17 17"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1h1v16H0zM7.86 11.139l.708.707 7.778-7.779-.707-.707z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.121 8.914h1v-5h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.793 4.585v-1h5v1zM0 0h11v1H0zm0 16h11v1H0z"
}))));
export default SvgExternalLinkSmall;